import script from "./license-layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./license-layout.vue?vue&type=script&setup=true&lang=ts"

import "./license-layout.vue?vue&type=style&index=0&id=5877a97f&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5877a97f"]])

export default __exports__